import { DrEntity } from './dr-entity';
import { DrObject, DrObjectType, SupportedRegExType } from './dr-object';

export class AliasListViewModel extends DrObject {
    model: Partial<AliasList>;
    constructor(value?: Partial<AliasList>) {
        super(DrObjectType.ALIAS_LIST, SupportedRegExType.PATTERNS);
        if (value) {
            this.model = value;
        }
    }
 }


export class AliasList extends DrEntity {
   aliases: Array<any>;
   description: string;
   name: string;
   parentHandle: string;

   constructor(value?: Partial<AliasList>) {
       super(value);
       if (value) {
           Object.assign(this, value);
       }
   }
}
